var angular = require('angular')
var langCs = require('./i18n/cs.js').cs
var langEn = require('./i18n/en.js').en

angular.module('inputRadioCmp', [])
  .factory('visibilityDependencyDataservice', require('../../../../services/visibility-dependency.dataservice'))
  .component('inputRadio', {
    template: require('./input-radio.component.tpl.html'),
    controller: InputRadioCtrl,
    controllerAs: 'vm',
    bindings: {
      formField: '<',
      value: '=',
      submitFormElementId: '<',
      sumbitFormByRadio: '&',
      disabledRadioButton: '<',
      resetVisibleFieldsValidity: '&'
    }
  })

InputRadioCtrl.$inject = ['visibilityDependencyDataservice', 'i18n']

function InputRadioCtrl (visibilityDependencyDataservice, i18n) {
  var vm = this
  vm.setOption = setOption
  vm.checkSumbitFormId = checkSumbitFormId
  vm.showLabel = true
  vm.changed = changed

  vm.$onInit = function () {
    i18n.appendLangFile('cs', langCs)
    i18n.appendLangFile('en', langEn)
    vm.fieldId = 'field_' + vm.formField.id + '-' + guid()
  }

  vm.$onChanges = function (changesObj) {
    if (changesObj.formField) {
      vm.type = getType()
    }
    if (vm.formField.businessName && vm.formField.businessName.indexOf('feedback') !== -1) {
      vm.showLabel = false
    }
  }

  if (vm.formField.defaultValueI18N) {
    setOption(vm.formField.defaultValueI18N)
  }

  function changed (id) {
    var value = vm.value[id]
    var visibleNow = visibilityDependencyDataservice.nodeValuesChanged(id, value)
    if (visibleNow.length) {
      vm.resetVisibleFieldsValidity()
    }
  }

  function checkSumbitFormId (submitFormElementId) {
    if (submitFormElementId === vm.formField.id) {
      vm.sumbitFormByRadio()
    }
  }

  function setOption (option) {
    vm.value[vm.formField.id] = option
  }

  function getType () {
    if (vm.formField.hidden) {
      return 'hidden'
    } else {
      return 'radio'
    }
  }

  function guid () {
    function s4 () {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
  }
}
